const e = {
  id: "MassachusettsTheNumbersGame",
  logo: !0,
  name: "The Numbers Game",
  style: {
    colorPrimary: "#01b2ff"
  }
};
export {
  e as default
};
